module.exports = __webpack_public_path__ + "img/摄像头.d9c6c8b5.png";